export const XSS_PROTECTION_HEADER = '1; mode=block';
